module.exports = __webpack_public_path__ + "static/img/globe-icon-updated.c372098e.svg";